module.exports = __webpack_public_path__ + "img/t2-black.e5745472.png";